import styles from "./RootLayout.module.css";
import Sidebar from "./Sidebar";
import Header from "./Header";

function ErrorPage() {
  return (
    <div className={styles.app}>
      <Header />
      <Sidebar />
    </div>
  );
}

export default ErrorPage;
